const messageModules = import.meta.glob<{ default: Record<string, any> }>(
    '../locales/compiled/app/messages/*.json',
);

const loadedMessages = new Map<string, Record<string, any>>();

/**
 * Loads the compiled message catalog for a locale on demand. Catalogs are
 * fetched as separate chunks so only the active locale is downloaded, and are
 * cached after the first load.
 */
export async function loadLocaleMessages(
    locale: string,
): Promise<Record<string, any>> {
    const cached = loadedMessages.get(locale);
    if (cached) {
        return cached;
    }

    for (const path in messageModules) {
        if (path.toLowerCase().endsWith(`/${locale}.json`)) {
            const module = await messageModules[path]();
            loadedMessages.set(locale, module.default);
            return module.default;
        }
    }

    return {};
}

/**
 * Returns the already-loaded catalog for a locale, or `undefined` when it has
 * not been fetched yet. For synchronous consumers (e.g. route module `meta`
 * exports) that cannot await `loadLocaleMessages`.
 */
export function getLoadedLocaleMessages(
    locale: string,
): Record<string, any> | undefined {
    return loadedMessages.get(locale);
}
